import { useEffect } from 'react';

/** L'écran redit « fil ouvert » plus souvent que le serveur ne l'oublie (60 s). */
const PRESENCE_MS = 30_000;

/**
 * Présence sur un fil de la messagerie ménage : signalée seulement quand la page
 * est VISIBLE (un onglet en arrière-plan ne doit pas couper les pushs du
 * téléphone), retirée quand elle se cache ou que le fil se ferme.
 */
export function usePresenceFil(filId: number, signaler: (id: number) => Promise<void>, retirer: (id: number) => Promise<void>): void {
    useEffect(() => {
        if (!filId) return undefined;

        const visible = () => typeof document === 'undefined' || document.visibilityState === 'visible';
        const tick = () => {
            if (visible()) void signaler(filId).catch(() => undefined);
        };
        const changement = () => (visible() ? tick() : void retirer(filId).catch(() => undefined));

        tick();
        const minuteur = window.setInterval(tick, PRESENCE_MS);
        document.addEventListener('visibilitychange', changement);

        return () => {
            window.clearInterval(minuteur);
            document.removeEventListener('visibilitychange', changement);
            void retirer(filId).catch(() => undefined);
        };
    }, [filId, signaler, retirer]);
}
